import React from 'react'; 
import '../styles/frontpage.css';

class Inactive extends React.Component {
    constructor(props){
        super(props); 

        this.state = {

        }
    }

    render() {
        return(
            <div className="py-5">
                <div style={{margin: 'auto', width: "50%", padding: "10px"}}>
                    <h5 className="pt-3">Account Inactive:</h5>
                    <p>Your account is currently set to <strong>inactive</strong> status. Please contact support at Adapticts.com.</p>
                </div>
            </div>
        )
    }

}

export default Inactive; 